module.exports = __webpack_public_path__ + "img/litterature.050b8537.jpg";